const invite = {
  not_found: 2203,
  duplicate: 2204,
};

export default invite;
